import {
  ActionAddTimer,
  ActionTimerBase,
  ActionTimersIntervalStart,
  ActionTimersIntervalStop,
  ActionTypes,
} from "./actionTypes";

export const DEFAULT_TIMER_TIME = 60;

export type Timers = { [key: string]: number };

interface TimersState {
  timers: Timers;
}

const initState: TimersState = {
  timers: {},
};

const reducer = (state = initState, action: ActionTimerBase) => {
  switch (action.type) {
    case ActionTypes.ADD_TIMER:
      const payload = (action as ActionAddTimer).payload;
      return {
        ...state,
        timers: {
          ...state.timers,
          ...payload,
        },
      };

    case ActionTypes.START_INTERVAL: {
      const payload = (action as ActionTimersIntervalStart).payload;
      return {
        ...state,
        timers: payload,
      };
    }

    case ActionTypes.STOP_INTERVAL: {
      const payload = (action as ActionTimersIntervalStop).payload;

      const timers = { ...state.timers };
      delete timers[payload];

      return {
        ...state,
        timers: timers,
      };
    }

    case ActionTypes.CLEAR_TIMERS:
      return {
        ...state,
        timers: {},
      };

    default:
      return state;
  }
};

export default reducer;
